import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { PRIMARY } from 'config/types/menu';
import { MENU } from 'config/types/prop';
import { options } from 'config/reactRedux';
import { getMenuTopLevel } from 'selectors/getMenu';
import withStyles from 'isomorphic-style-loader/withStyles';

import NavItem from '../navItem';
import styles from './primaryNav.css';

const PrimaryNav = ({ items }) => (
  <nav className={classNames(styles.wrapper, 'primaryNav')}>
    <ul>
      {items.map(({
        id,
        label,
        url,
        slug,
      }) => (
        <NavItem
          key={id}
          url={url || `/${slug}`}
          label={label}
        />
      ))}
    </ul>
  </nav>
);

PrimaryNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(MENU)).isRequired,
};

export const mapStateToProps = (state) => ({
  items: getMenuTopLevel(state, PRIMARY),
});

const withRedux = connect(
  mapStateToProps,
  undefined,
  undefined,
  options,
);

export default withRedux(withStyles(styles)(PrimaryNav));

